import * as React from 'react';

import TablePagination from '@material-ui/core/TablePagination';

import Article from '../Article/Article';
import { IProps } from './interfaces';

import styles from './Category.module.styl';

const MIN_PAGINATION_LIMIT = 10;

class Category extends React.Component<IProps> {
  public render() {
    const {
      data: { articles, category, pagination },
      locale,
      handleChangePage,
      handleChangeRowsPerPage,
    } = this.props;

    const categoryContent =
      (locale && category?.translation[locale]) || category;

    return (
      <div className={styles.root}>
        {articles.length === 0 && (
          <div className={styles.header}>{categoryContent.title}</div>
        )}
        {articles.length === 0 && (
          <div
            className={styles.content}
            // eslint-disable-next-line react/no-danger
            dangerouslySetInnerHTML={{
              __html: categoryContent.description,
            }}
          />
        )}
        {articles.map((article: any) => (
          <div key={article.id} className={styles.wrapper}>
            <Article data={{ article }} preview={true} />
          </div>
        ))}
        {pagination && pagination.total > MIN_PAGINATION_LIMIT && (
          <TablePagination
            component="div"
            count={pagination.total}
            rowsPerPage={pagination.limit}
            page={pagination.page}
            backIconButtonProps={{
              'aria-label': 'Previous Page',
            }}
            nextIconButtonProps={{
              'aria-label': 'Next Page',
            }}
            className={styles.pagination}
            onChangePage={handleChangePage}
            onChangeRowsPerPage={handleChangeRowsPerPage}
          />
        )}
      </div>
    );
  }
}

export default Category;
